export default "__VITE_ASSET__DzoRiOV$__"